import { useReveal } from '../hooks/useReveal';
import './FinalCta.scss';

/**
 * Final CTA — large block, two-button repeat of the hero, with the
 * aurora bleeding through a soft inner border. Sits between the FAQ
 * and the footer so the page ends on a "do it" beat instead of
 * fading out.
 */
export function FinalCta() {
	const ref = useReveal<HTMLDivElement>();
	return (
		<section class="m-final" ref={ref}>
			<div class="m-final__inner">
				<h2 class="m-final__title">
					stop emailing screenshots.
					<br />
					<span class="m-final__accent">start commenting on the actual page.</span>
				</h2>
				<p class="m-final__sub">
					One project. Five members. Unlimited commenters. Forever, on the free tier.
				</p>
				<div class="m-final__cta-row">
					<a class="m-btn m-btn--primary" href="#pricing">
						Start free
					</a>
					<a class="m-btn m-btn--ghost" href="https://github.com/rw3iss/pageloop">
						View on GitHub
					</a>
				</div>
				<p class="m-final__foot">
					<code>npm i -g @pageloop/cli</code>
					<span>·</span>
					<code>pageloop login</code>
				</p>
			</div>
		</section>
	);
}
